<template>
  <div class="animated fadeIn mt-3" id="report">
    <h1 class="text-uppercase font-weight-bold">Dashboard comercial</h1>
    <b-card id="element-to-hide" data-html2canvas-ignore="true" v-if="false">
      <b-row>
        <b-col sm="12" md="6" lg="6">
          <b-form-group label="Exportadora">
            <b-form-select
              size="sm"
              id="client_customer"
              v-model="client_customer"
              :options="client_customer_options"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col sm="12" md="6" lg="6">
          <b-form-group label="Especie">
            <b-form-select size="sm" id="product" v-model="product" :options="product_options"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <div>
      <b-row>
        <b-col :lg="6" :md="6" :sm="12">
          <b-card class="chart h-80">
            <h4>Kilos Exportados</h4>
            <p class="font-italic">Total de kilos exportados a la fecha</p>
            <p class="kpi text-dark">
              {{ total_exports | thousandSeparator }} <span class="kpi-unit">Kg</span> / 400.000
              <span class="kpi-unit">Kg</span>
            </p>
            <b-progress :value="total_exports" :max="400000" show-progress animated></b-progress>
          </b-card>
        </b-col>
        <b-col :lg="6" :md="6" :sm="12">
          <b-card class="h-80">
            <h4>Consignees</h4>
            <p class="font-italic">Total de kilos exportados por consignee</p>
            <b-table-simple :items="total_exports_by_country">
              <template v-for="item in total_exports_by_country">
                <b-tr>
                  <b-td>{{ item.pallet__dispatch_waybill__exportwaybill__shipment__consignee_company__name }}</b-td>
                  <b-td class="text-right">{{ item.s_kg | thousandSeparator }}</b-td>
                </b-tr>
              </template>
            </b-table-simple>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="$store.state.user.scope.includes('dashboard_comercial:ver_todo')">
        <b-col :lg="3" :md="6" :sm="12">
          <b-card class="chart">
            <h4>Kilos liquidados</h4>
            <p class="font-italic">
              Total de kilos liquidados a la fecha ({{ (sum_total_kg / total_exports) | percentage }})
            </p>
            <p class="kpi text-primary">{{ sum_total_kg | thousandSeparator }} <span class="kpi-unit">Kg</span></p>
          </b-card>
        </b-col>
        <b-col :lg="3" :md="6" :sm="12">
          <b-card class="chart">
            <h4>Comision acumulada</h4>
            <p class="font-italic">8% de FOB total acumulado</p>
            <p class="kpi">{{ total_exporter | currency }} <span class="kpi-unit">USD</span></p>
          </b-card>
        </b-col>
        <b-col :lg="3" :md="6" :sm="12">
          <b-card class="chart">
            <h4>RNP / KG</h4>
            <p class="font-italic">Promedio retorno neto a productor</p>
            <p class="kpi">{{ avg_rnp | currency }} <span class="kpi-unit">USD/Kg</span></p>
          </b-card>
        </b-col>
        <b-col :lg="3" :md="6" :sm="12">
          <b-card class="chart">
            <h4>Renta de la operacion</h4>
            <p class="font-italic">Total FOB menos gastos totales (USD)</p>
            <p
              :class="{
                kpi: true,
                'text-success': revenue > 0,
                'text-danger': revenue < 0
              }"
            >
              {{ revenue | currency }} <span class="kpi-unit">USD</span>
            </p>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="$store.state.user.scope.includes('dashboard_comercial:ver_todo')">
        <b-col :lg="6" :md="12" :sm="12">
          <b-card class="chart">
            <h4>Exportado en USD</h4>
            <p class="font-italic">
              Total liquidado vs el total pendiente <b class="text-primary">US {{ totalExportUsd | bigNumber }}</b>
            </p>
            <ExportadoUsd :data-ready="ready" :chart-data="exportedChartData" />
          </b-card>
        </b-col>
        <b-col :lg="6" :md="12" :sm="12">
          <b-card class="chart">
            <h4>Gasto por ítem</h4>
            <p class="font-italic">
              Total gastado por ítem de costo. <b class="text-danger">US {{ totalCostoItemUsd | bigNumber }}</b>
            </p>
            <CostoItem :data-ready="ready" :chart-data="costoItemData" />
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="false">
        <b-col :lg="6" :md="12" :sm="12">
          <b-card class="chart">
            <h4>M&S por formato</h4>
            <p class="font-italic">Comparativo de m&s por formato</p>
            <Mys />
          </b-card>
        </b-col>
        <b-col :lg="6" :md="12" :sm="12">
          <b-card class="chart">
            <h4>RNP por productor</h4>
            <p class="font-italic">Retorno neto productor detallado</p>
            <Rnp />
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import Mys from "./Mys.vue";
import Rnp from "./Rnp.vue";
import ExportadoUsd from "./ExportadoUsd.vue";
import CostoItem from "./CostoItem.vue";
export default {
  name: "charts",
  components: {
    Mys,
    Rnp,
    ExportadoUsd,
    CostoItem
  },
  filters: {
    percentage: function (value) {
      // Internationalization of currency
      return new Intl.NumberFormat("es-CL", {
        style: "percent",
        minimumFractionDigits: 2
      }).format(value);
    },
    thousandSeparator: function (value) {
      // Internationalization of currency
      return new Intl.NumberFormat("es-CL").format(value);
    },
    currency: function (value) {
      // Internationalization of currency
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(value);
    },
    bigNumber: function (value) {
      // Internationalization of currency
      return new Intl.NumberFormat("en-US", {
        notation: "compact",
        compactDisplay: "short"
      }).format(value);
    }
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // 15th two months prior
    const minDate = new Date(today);
    minDate.setMonth(minDate.getMonth() - 1);
    // 15th in two months
    const maxDate = new Date(today);

    return {
      ready: false,
      beginMount: [],
      minDate: minDate,
      maxDate: maxDate,
      from_date: minDate.toISOString().split("T")[0],
      to_date: now.toISOString().split("T")[0],
      product: null,
      product_options: [],
      product_type: null,
      product_type_options: [],
      process_type: null,
      process_type_options: [],
      client_customer: null,
      client_customer_options: [],
      total_exporter: 0,
      avg_rnp: 0,
      sum_total_kg: 0,
      revenue: 0,
      total_exports: 0,
      total_exports_by_country: [],
      export_table_fields: [
        {
          key: "pallet__dispatch_waybill__exportwaybill__shipment__consignee_company__name",
          label: "Consignee"
        },
        {
          key: "s_kg",
          label: "Kg",
          class: "text-right"
        }
      ],
      costoItemData: {},
      exportedChartData: {}
    };
  },
  computed: {
    totalExportUsd() {
      if (this.exportedChartData.dataset) {
        return this.exportedChartData.dataset.reduce((a, b) => a + b, 0);
      } else {
        return 0;
      }
    },
    totalCostoItemUsd() {
      if (this.costoItemData.dataset) {
        return this.costoItemData.dataset.reduce((a, b) => a + b, 0);
      } else {
        return 0;
      }
    }
  },
  watch: {
    client_customer(newVal, oldVal) {
      this.refreshData();
    },
    product(newVal, oldVal) {
      this.refreshData();
    },
    product_type(newVal, oldVal) {
      this.refreshData();
    }
  },
  methods: {
    refreshData() {
      this.beginMount = [];
      this.ready = false;
      this.$nextTick((_) => {
        this.ready = true;
      });
    },
    getCustomers() {
      this.$axios
        .get("/production/get_customers/")
        .then((res) => {
          const data = res.data.data;
          const customers = [];
          for (let key in data) {
            const customer = data[key];
            customers.push(customer);
          }
          this.client_customer_options = customers;
          this.client_customer_options.unshift({ text: "Todo", value: null });
        })
        .catch((error) => console.log(error));
    },
    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.product_options = products;
          this.product_options.unshift({ text: "Todo", value: null });
        })
        .catch((error) => console.log(error));
    },
    getProductTypes() {
      this.$axios
        .get("/production/get_product_types/")
        .then((res) => {
          const data = res.data.data;
          const product_types = [];
          for (let key in data) {
            const product_type = data[key];
            product_types.push(product_type);
          }
          this.product_type_options = product_types;
          this.product_type_options.unshift({ text: "Todo", value: null, exportable: null });
        })
        .catch((error) => console.log(error));
    },
    fetchData() {
      this.$axios
        .get("/api/comex/groweradvancesummary/dashboard/")
        .then((res) => {
          const data = res.data;
          this.total_exporter = data.sum_total_exporter;
          this.avg_rnp = data.avg_rnp;
          this.sum_total_kg = data.sum_total_kg;
          this.revenue = data.revenue;
          this.total_exports = data.total_exports;
          this.exportedChartData = data.exported_chart_data;
          this.total_exports_by_country = data.total_exports_by_country;
          // Truncate cost_chart_data to just 5 items and add the rest to "Otros"
          const cost_chart_data = data.cost_chart_data;
          const cost_chart_data_truncated = cost_chart_data.dataset.slice(0, 5);
          const cost_chart_data_labels_truncated = cost_chart_data.labels.slice(0, 5);
          cost_chart_data_labels_truncated.push("Otros");
          const cost_chart_data_others = cost_chart_data.dataset.slice(5);
          const cost_chart_data_others_sum = cost_chart_data_others.reduce((a, b) => a + b, 0);
          cost_chart_data_truncated.push(cost_chart_data_others_sum);

          this.costoItemData = {
            labels: cost_chart_data_labels_truncated,
            dataset: cost_chart_data_truncated
          };
        })
        .catch((error) => console.log(error));
    }
  },
  async mounted() {
    this.loading = true;
    await this.getCustomers();
    await this.getProducts();
    await this.getProductTypes();
    await this.fetchData();
    this.ready = true;
  }
};
</script>

<style scoped>
.card {
  border-radius: 10px;
  /* Apply soft shadow */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.kpi {
  font-size: 2rem;
  font-weight: bold;
  color: #5c6873;
}
.kpi-unit {
  font-size: 1.5rem;
  font-weight: normal;
  color: #5c6873;
}
</style>
